import { CheckIcon, RepeatIcon } from '@chakra-ui/icons'
import { Button, Flex, Text } from '@chakra-ui/react'
import { CollapseHorizontal } from '../../shared'
import { useExternalPdfTemplateEditor } from './context'

export const SaveButtons = () => {
  const { submitExternalPdfChanges, submittingChanges, resetExternalPdf, externalPdfChanged } =
    useExternalPdfTemplateEditor()
  return (
    <CollapseHorizontal width={180} in={externalPdfChanged}>
      <Flex width="160px" align="center" gap={1.5}>
        <Button size="xs" gap={1} variant="outline" onClick={resetExternalPdf}>
          <Text>RESET</Text>
          <RepeatIcon />
        </Button>
        <Button
          size="xs"
          bg="green.500"
          gap={1}
          color="white"
          _hover={{ bg: 'green.400' }}
          onClick={submitExternalPdfChanges}
          isLoading={submittingChanges}>
          <Text>SAVE</Text>
          <CheckIcon />
        </Button>
      </Flex>
    </CollapseHorizontal>
  )
}
